module.exports = __webpack_public_path__ + "img/cbanner.35a4e318.png";